import { render, staticRenderFns } from "./CustomerPiutang.vue?vue&type=template&id=0871b018"
import script from "./CustomerPiutang.vue?vue&type=script&lang=js"
export * from "./CustomerPiutang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports